import { ref, computed, onMounted } from 'vue-demi';
import FEGORender from '@futuweb/fego-render';
import { TIME_LIMIT, DISPLAY_TYPE } from '../../constants';
import 'intersection-observer';
import Cache from '../../fego/Cache';
const { useEnv } = require('@fegobull/webapi').use;
const { isPreRender } = useEnv();

const { store: { variable }, library } = FEGORender;
const { dayjs } = library;

export default function usePureDisplayClose({ enableCloseBtn, closeTimeLimit }) {
    const displayBox = ref(DISPLAY_TYPE.HIDDEN);
    const urlSuffix = variable.data.URL_SUFFIX;
    const cache = new Cache({
        prefix: `fixed-box-${urlSuffix}`
    });
    // 关闭标识
    const closeSign = computed(() => {
        return `close_${closeTimeLimit}`;
    });

    /**
     * 初始化显示状态
     */
    const initDisplayStatus = () => {
        let flag = DISPLAY_TYPE.DISPLAY;
        if (enableCloseBtn) {
            flag = DISPLAY_TYPE.CLOSE;
            const cacheStatus = cache.getCacheStatus(closeSign.value);
            switch (closeTimeLimit) {
                case TIME_LIMIT.DAY:
                    const expTime = dayjs(cacheStatus * 1e3 + 24 * 60 * 60 * 1000).unix();
                    const now = dayjs().unix();
                    if (expTime < now) {
                        flag = DISPLAY_TYPE.DISPLAY;
                    }
                    break;
                case TIME_LIMIT.FOREVER:
                    flag = cacheStatus ? DISPLAY_TYPE.CLOSE : DISPLAY_TYPE.DISPLAY;
                    break;
                default:
                    flag = DISPLAY_TYPE.DISPLAY;
                    break;
            }
        }
        displayBox.value = flag;
    };

    /**
     * 关闭容器
     */
    const close = () => {
        // 缓存关闭状态
        switch (closeTimeLimit) {
            case TIME_LIMIT.DAY:
                cache.setCacheStatus(closeSign.value, dayjs().unix());
                break;
            case TIME_LIMIT.FOREVER:
                cache.setCacheStatus(closeSign.value, '1');
                break;
            default:
                break;
        }
        displayBox.value = DISPLAY_TYPE.CLOSE;
    };

    onMounted(() => {
        if (isPreRender) {
            return;
        }
        initDisplayStatus();
    });

    return {
        displayBox,
        close
    };
}
